import GetFetch from '../common/GetFetch';

const Fetcher =  (years) => {
    const URI = `dashboard/summary/yearly/${years.join()}`;

    return GetFetch(URI);
}

export default Fetcher;
